export class Environment {
  /**
   * 環境変数.Api URLを取得する
   * @return API URL
   */
  public static getApiEndpoint = () => {
    return Environment.get("REACT_APP_GET_API_ENDPOINT");
  };
  /**
   * get Environmenal variable Build type
   * @return Build Type
   */
  public static getBuildType = () => {
    return Environment.get("REACT_APP_GET_BUILD");
  };
  /**
   * get Environmenal variable Firebase Api Key
   * @return Firebase Api Key
   */
  public static getFirebaseApiKey = () => {
    return Environment.get("REACT_APP_GET_FIREBASE_APIKEY");
  };
  /**
   * get Environmenal variable Firebase Auth Domain
   * @return Firebase Auth Domain
   */
  public static getFirebaseAuthDomain = () => {
    return Environment.get("REACT_APP_GET_FIREBASE_AUTHDOMAIN");
  };
  /**
   * get Environmenal variable Google Recaptcha
   * @return Google Re Captcha key
   */
  public static getRecaptchaKey = () => {
    return Environment.get("REACT_APP_GET_RECAPTCHA_KEY");
  };
  /**
   *
   * get Environmenal variable Firebase Project Id
   * @return Firebase Project Id
   */
  public static getFirebaseProjectId = () => {
    return Environment.get("REACT_APP_GET_FIREBASE_PROJECTID");
  };
  /**
   * get Environmenal variable Firebase Storage Bucket
   * @return Firebase Storage Bucket
   */
  public static getFirebaseStorageBucket = () => {
    return Environment.get("REACT_APP_GET_FIREBASE_STORAGEBUCKET");
  };
  /**
   * get Environmenal variable Firebase Messaging Id
   * @return Firebase Messaging Id
   */
  public static getFirebaseMessagingSenderId = () => {
    return Environment.get("REACT_APP_GET_FIREBASE_MESSAGINGSENDERID");
  };
  /**
   * get Environmenal variable Firebase App Id
   * @return Firebase App Id
   */
  public static getFirebaseAppId = () => {
    return Environment.get("REACT_APP_GET_FIREBASE_APPID");
  };
  /**
   * get Environmenal variable Firebase Measurement Id
   * @return Firebase Measurement Id
   */
  public static getFirebaseMeasurementId = () => {
    return Environment.get("REACT_APP_GET_FIREBASE_MEASUREMENTID");
  };
  /**
   * get Environmenal variable Default Auth Id
   * @return Default Auth Id
   */
  public static getDefaultAuthId = () => {
    return Environment.get("REACT_APP_GET_DEFAULT_AUTH");
  };
  /**
   * get Environmenal variable Payjp Id
   * @return Payjp Id
   */
  public static getPayjpId = () => {
    return Environment.get("REACT_APP_GET_PAYJP_ID");
  };
  /**
   * 指定した環境変数の値を取得する
   * @param {string} key 環境変数のKey名
   * @return 指定した環境変数の値
   */
  public static get = (key: string) => {
    let res = process.env[key];
    if (key === null || key === undefined || key === "") {
      console.log(`環境変数 ${key}が設定されていません`, {
        res,
      });

      throw new Error(
        `Fatal Error: Not Configured Environment Value "${key}" `
      );
    }
    if (res === undefined) {
      res = "";
    }
    return res;
  };
}
